// Import Libraries
import React, { useEffect, useState } from "react";
import { Alert, AlertTitle } from "@material-ui/lab";
import PropTypes from "prop-types";
import moment from "moment";

// Import API Services
import { getClientMessages } from "../../api/Clients";
import { Tooltip, Typography } from "@material-ui/core";

export default function StoreAlertMesage(props) {
  const { clientId = localStorage.getItem("client_id"), productId = null } =
    props;
  const [message, setMessage] = useState(null);

  // Initial values
  useEffect(() => {
    // Get client alert message
    if (clientId || productId) {
      getAlertMessage();
    }
  }, [clientId, productId]);

  /**
   * Get Client Alert Message
   */
  const getAlertMessage = () => {
    getClientMessages(clientId, productId).then((result) => {
      if (
        result &&
        result.data &&
        result.data.informationMessages &&
        Array.isArray(result.data.informationMessages) &&
        result.data.informationMessages.length !== 0
      ) {
        // Get first message
        setMessage(result.data.informationMessages[0]);
      }
    });
  };

  return (
    <div>
      {message &&
        message.id &&
        moment(message.startDate).isSameOrBefore(moment(), "day") &&
        moment(message.endDate).isSameOrAfter(moment(), "day") &&
        (productId ? (
          <Tooltip title={message.message}>
            <Typography
              variant="caption"
              style={{
                color: "#1976d2",
                display: "-webkit-box",
                overflow: "hidden",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                width: "100%",
              }}
            >
              {message?.message}
            </Typography>
          </Tooltip>
        ) : (
          <Alert severity="info">
            <AlertTitle>
              <b>{message.message}</b>
            </AlertTitle>
          </Alert>
        ))}
    </div>
  );
}

StoreAlertMesage.propTypes = {
  clientId: PropTypes.string,
  productId: PropTypes.string,
};
